import React from 'react';
import { Flex, Text, H3, Box } from '@opendoor/bricks/core';
import { UNSAFE_DatePicker } from '@opendoor/bricks/deprecated/UNSAFE_DatePicker';
import { LocalDate, nativeJs, ZonedDateTime } from '@js-joda/core';

/** TODO: Add documentation */
export const DatePickerWrapper: React.FC<{
  onClick: (date: LocalDate) => void;
  options: LocalDate[];
  title: string;
  subtitle?: string;
  initialDate?: React.ComponentProps<typeof UNSAFE_DatePicker>['initialDate'];
}> = ({ initialDate, options, onClick, title, subtitle }) => {
  return (
    <>
      <Box my={5} textAlign="center">
        <H3>{title}</H3>
        {subtitle && (
          <Text fontSize="s1" lineHeight="s0">
            {subtitle}
          </Text>
        )}
      </Box>
      <Flex
        flexDirection="column"
        justifyContent="center"
        alignItems="center"
        width="100%"
        data-testid="date-picker"
      >
        <UNSAFE_DatePicker
          initialDate={initialDate}
          onDateChange={(date: Date) => {
            const localDate = jsDateToLocalDate(date);
            onClick(localDate);
          }}
          isOutOfRange={(date: Date) => {
            const localDate = jsDateToLocalDate(date);
            return options.every((option) => !option.equals(localDate));
          }}
        />
      </Flex>
    </>
  );
};

const jsDateToLocalDate = (date: Date) => ZonedDateTime.from(nativeJs(date)).toLocalDate();
